import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "../../assets/styles/main.css";

export default function SuccessMercadoPago() {
  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        (window as any).ReactNativeWebView.postMessage("NAVIGATE_HOME");
      } catch {
        // fallback for non-WebView context
        window.location.href = "com.maxdreamapp://url_mp_success";
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="cs-congrats-page">
      <div className="cs-congrats-card">
        <div className="cs-congrats-icon-wrap">
          <FontAwesomeIcon icon={faCheckCircle} className="cs-congrats-icon" />
        </div>
        <h2 className="cs-congrats-title">¡Pago exitoso!</h2>
        <p className="cs-congrats-subtitle">
          Tu pago fue procesado correctamente.{"\n"}
          En breve podrás ver los servicios actualizados.
        </p>
        <div className="cs-congrats-loader">
          <span>Volviendo al inicio</span>
          <span className="cs-congrats-dots">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>
    </div>
  );
}
